import { render } from "./popUp.vue?vue&type=template&id=5b61e04d&scoped=true"
import script from "./popUp.vue?vue&type=script&lang=js"
export * from "./popUp.vue?vue&type=script&lang=js"

import "./popUp.vue?vue&type=style&index=0&id=5b61e04d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b61e04d"]])

export default __exports__